import { render, staticRenderFns } from "./linkage.vue?vue&type=template&id=4327314a&scoped=true&"
import script from "./linkage.vue?vue&type=script&lang=js&"
export * from "./linkage.vue?vue&type=script&lang=js&"
import style0 from "./linkage.vue?vue&type=style&index=0&id=4327314a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327314a",
  null
  
)

export default component.exports